import { Link } from 'react-router-dom';

function LinkButton({ children, link, className = 'rounded-md px-6 py-3' }) {
  return (
    <Link
      to={link}
      className={`transition-all duration-300 text-base font-semibold inline-block hover:bg-[#facc15] bg-[#ffde11]  ${className ? className : ''}`}
    >
      {children}
    </Link>
  );
}

export default LinkButton;
